import { GetCardDetailsQuery, GetCardDetailsQueryVariables } from '@/types';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';

export const GET_CARD_DETAILS_QUERY = gql`
  query GetCardDetails($encryptedCardNumber: String!) {
    getCardDetails(encrypted_card_number: $encryptedCardNumber) {
      funding_source
    }
  }
`;

export const useGetCardDetails = () => {
  return useLazyQuery<GetCardDetailsQuery, GetCardDetailsQueryVariables>(
    GET_CARD_DETAILS_QUERY,
    {
      fetchPolicy: 'network-only',
    },
  );
};
